import React from 'react';
import { Divider } from '@ui';
import { Flex } from 'antd';
import MenuAccountItem from '../MenuAccountItem';
import { StyledFlex } from './styled';

const MenuAccountItems = ({ items }) => {
    const columns = {
        primary: items.slice(0, 5),
        secondary: items.slice(5, 10),
        additional: items.slice(10)
    };

    const hasTwoColumns = columns.secondary.length > 0;
    const hasAdditionalItems = columns.additional.length > 0;
    const containerWidth = hasTwoColumns ? 550 : 292;

    const renderColumn = (columnItems) => {
        if (!columnItems.length) return null;

        return (
            <Flex style={{ width: 224 }} vertical>
                {columnItems.map((item, i) => (
                    <MenuAccountItem key={i} item={item} />
                ))}
            </Flex>
        );
    };

    const renderAdditionalItems = () => {
        if (!hasAdditionalItems) return null;

        const additionalColumnOne = columns.additional.filter((_, i) => i % 2 === 0);
        const additionalColumnTwo = columns.additional.filter((_, i) => i % 2 === 1);

        return (
            <React.Fragment>
                <Divider margin={0} />
                <Flex gap={24} wrap style={{ width: '100%' }}>
                    {additionalColumnOne.length > 0 && (
                        <Flex style={{ width: 224 }} vertical>
                            {additionalColumnOne.map((item, i) => (
                                <MenuAccountItem key={i} item={item} />
                            ))}
                        </Flex>
                    )}

                    {additionalColumnTwo.length > 0 && (
                        <Flex style={{ width: 224 }} vertical>
                            {additionalColumnTwo.map((item, i) => (
                                <MenuAccountItem key={i} item={item} />
                            ))}
                        </Flex>
                    )}
                </Flex>
            </React.Fragment>
        );
    };

    return (
        <StyledFlex
            gap={24}
            wrap
            data-e2e='header_user-dropdown-menu_accounts'
            component='ul'
            style={{ width: containerWidth }}
        >
            {hasTwoColumns && renderColumn(columns.secondary)}
            {renderColumn(columns.primary)}
            {renderAdditionalItems()}
        </StyledFlex>
    );
};

export default MenuAccountItems;
